var exports = {
  "Qs": "DebugModal.module__content___NXpCX2",
  "kL": "DebugModal.module__container___NXpCX2",
  "sN": "DebugModal.module__tabsSection___NXpCX2",
  "vR": "DebugModal.module__tabs___NXpCX2",
  "P1": "DebugModal.module__scrollArea___NXpCX2",
  "z": "DebugModal.module__summary___NXpCX2",
  "hZ": "DebugModal.module__summaryTitle___NXpCX2",
  "D_": "DebugModal.module__summaryBody___NXpCX2",
  "Ip": "DebugModal.module__summaryItem___NXpCX2",
  "rG": "DebugModal.module__summaryLabel___NXpCX2",
  "Qb": "DebugModal.module__summaryValue___NXpCX2",
  "ZP": "DebugModal.module__codeSection___NXpCX2",
  "Dy": "DebugModal.module__codeSurface___NXpCX2",
};

module.exports = exports;
